import { Config, SettingsConfig } from "./configType";

export const fgfSettings: SettingsConfig = {
  apiManagement: process.env.REACT_APP_FGF_APIM,
  ocpApimSubscriptionKey: process.env.REACT_APP_FGF_APIM_KEY,
  googleApiKey: process.env.REACT_APP_FGF_GOOGLE_API_KEY,
  authority: process.env.REACT_APP_FGF_AUTHORITY,
  bankStatementIframeUrl: process.env.REACT_APP_FGF_BANK_STATEMENTS_IFRAME,
  authUrl: process.env.REACT_APP_FGF_AUTH_URL,
  appUrl: process.env.REACT_APP_FGF_APP_URL,
  cookieDomain: process.env.REACT_APP_FGF_COOKIE_DOMAIN,
  authClientId: process.env.REACT_APP_FGF_AUTH_CLIENT_ID,
  newCustomerForm: process.env.REACT_APP_FGF_NEW_CUSTOMER_FORM,
  contentManagementUrl: process.env.REACT_APP_FGF_CDS_URL,
  contentToken: process.env.REACT_APP_FGF_CDS_TOKEN,
  ezidebitUrl:  process.env.REACT_APP_FGF_EZIDEBIT_URL,
  gtmId: process.env.REACT_APP_FGF_GTM_ID,
  gtmAuth: process.env.REACT_APP_FGF_GTM_AUTH,
  gtmPreview: process.env.REACT_APP_FGF_GTM_PREVIEW,
  phone: process.env.REACT_APP_FGF_PHONE,
  email: process.env.REACT_APP_FGF_EMAIL,
  abn: process.env.REACT_APP_FGF_ACN,
  acl: process.env.REACT_APP_FGF_ACL,
  faq: process.env.REACT_APP_FGF_FAQ,
  companyName: process.env.REACT_APP_FGF_COMPANY_NAME,
  privacy: process.env.REACT_APP_FGF_PRIVACY_POLICY,
  cdsPrefix: process.env.REACT_APP_FGF_CDS_PREFIX,
  cdsApp: process.env.REACT_APP_FGF_CDS_APP,
  privacyConsentAndElectronicAuthorisation: process.env.REACT_APP_FGF_PRIVACY_CONSENT_AND_ELECTRONIC_AUTHORISATION,
  creditGuide: process.env.REACT_APP_FGF_CREDIT_GUIDE,
  directDebitBank: process.env.REACT_APP_FGF_DIRECT_DEBIT_BANK,
  directDebitBSB: process.env.REACT_APP_FGF_DIRECT_DEBIT_BSB,
  directDebitAccountNumber: process.env.REACT_APP_FGF_DIRECT_DEBIT_ACCOUNT_NUMBER,
  vwoAccountId: process.env.REACT_APP_FGF_VWO_ACCOUNT_ID,
  magicBlocksWorkspaceId: process.env.REACT_APP_FGF_MAGICBLOCKS_WORKSPACE_ID,
  magicBlocksExperienceId: process.env.REACT_APP_FGF_MAGICBLOCKS_EXPERIENCE_ID,
  magicBlocksTestMode: process.env.REACT_APP_FGF_MAGICBLOCKS_TEST_MODE
};

export const fgfConfig: Config = {
  partnerLogo: 'fairgo-partnership-logo.svg',
  LOCName: "Line of Credit"
};

export const fgfFavicon = '/favicon-fgf.png';